export default __webpack_public_path__ + "static/media/project-school.912e8551.jpg";